import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Falls back to "development", matching the backend's DEFAULT_SENTRY_ENVIRONMENT
  // (src/aa_backend/lib/logging.py). A bundle built without the build arg is a
  // local one; defaulting it to "production" filed dev noise alongside the real
  // thing and made environment filtering unreliable (#1101). A prod release
  // passes `production` explicitly (.github/workflows/deploy.yml, through the
  // deploy-target registry's sentry_environment).
  //
  // `||`, not `??`: an ARG declared but not passed reaches `npm run build` as an
  // empty string, which CRA inlines verbatim — `??` would let that through as a
  // blank environment.
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
  // Baked in at build time by docker/Dockerfile.frontend. Left undefined the
  // SDK reports no release, which is the correct answer for an unversioned
  // local build — better than claiming a version it cannot know.
  release: process.env.REACT_APP_SENTRY_RELEASE,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
  // Errors only — no `browserTracingIntegration`, no `tracesSampleRate` (#1434).
  // Browser tracing opened a transaction per navigation and per XHR, and the
  // app polls `/api/research/runs/active/` every 5s from every open tab.
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
